/* eslint-disable react/no-array-index-key */

import React, { PureComponent } from 'react';

import CheckoutPaymentItem from '../item';

import styles from './index.module.scss';

export default class CheckoutPaymentList extends PureComponent {
    render() {
        const {
            list,
            activeId,
            updateOrderPaymentMethod,
            fetching,
            noMarginBottom,
            modalMarginBottom,
        } = this.props;
        const single = list.length === 1;

        return (
            <div
                className={`${styles.checkoutPaymentList} ${
                    noMarginBottom ? styles['checkoutPaymentList--noMarginBottom'] : ''
                } ${modalMarginBottom ? styles['checkoutPaymentList--modalMarginBottom'] : ''}`}
            >
                {list.map((paymentMethod, index) => {
                    const active = paymentMethod.id === activeId;

                    return (
                        <CheckoutPaymentItem
                            active={active}
                            paymentMethod={paymentMethod}
                            key={index}
                            single={active && single}
                            onClick={() =>
                                !active &&
                                updateOrderPaymentMethod(paymentMethod.id, paymentMethod.type)
                            }
                            loading={fetching}
                        />
                    );
                })}
            </div>
        );
    }
}
